/**
* Gallery Popup JS
* -----------------------------------------------------------------------------
*
* All the JS for the Gallery Popup component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'gallery-popup',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      let currentSlider = false;
      $( '.gallery-popup-trigger' ).magnificPopup( {
        type: 'inline',
        callbacks: {
          open: function() {
            // console.log( $( this.currItem.el ).attr( 'data-key' ) );
            let initialSlide = 0;

            if ( $( this.currItem.el ).attr( 'data-key' ) ) {
              initialSlide = $( this.currItem.el ).attr( 'data-key' );
            }

            $( '.gallery-popup.splide' ).each( function( index, comp ) {
              currentSlider = new Splide( comp, {
                type: 'fade',
                perPage: 1,
                perMove: 1,
                gap: '50px',
                start: initialSlide,
                pagination: false,
                drag: false,
                live: true,
              } );

              currentSlider.on( 'overflow', function( isOverflow ) {
                currentSlider.options = {
                  arrows: isOverflow,
                };
              } );

              const handleCaptions = ( index ) => {
                const destinationSlide = $( $( '.splide__slide' ).eq( index ).get( 0 ) ).find( '.image' ).get( 0 );
                $( '.mfp-content .gallery-popup .title' ).text( $( destinationSlide ).attr( 'data-title' ) );
                $( '.mfp-content .gallery-popup .caption' ).text( $( destinationSlide ).attr( 'data-caption' ) );
                $( '.mfp-content .gallery-popup .current-page' ).text( index + 1 );
              };

              // Updates the bar width whenever the carousel moves:
              currentSlider.on( 'mounted', function( ) {
                handleCaptions( parseInt( initialSlide ) );
              } );
              // Updates the bar width whenever the carousel moves:
              currentSlider.on( 'move', function( newIndex, prevIndex, destIndex ) {
                handleCaptions( destIndex );
              } );

              currentSlider.mount();
            } );
          },
          close: function() {
            currentSlider.destroy();
          },
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'gallery-popup', COMPONENT );
} )( app );
